<template>
    <v-container fluid class="text-xs-center"> 
        <v-layout row wrap>
            
            <span class="field-title">{{$t('labels.binomial')}}</span>
            <span class="field-value italic" style="font-weight: 600;">{{research.full}}</span>
            <span class="field-title">{{$t('labels.reference')}}</span>
            <span class="field-value">{{research.reference}}</span>
            <span class="field-title">{{$t('labels.year')}}</span>
            <span class="field-value">{{research.year}}</span>
            <span class="field-title" v-if="research.abc">a,b,c...</span>
            <span class="field-value" v-if="research.abc">{{research.abc}}</span>
            <span class="field-title">{{$t('labels.notes')}}</span>
            <span class="field-value">{{research.notes}}</span>
            <span class="field-title">{{$t('labels.specimenCount')}}</span>
            <span class="field-value">{{research.specimenCount}}</span>
            <span class="field-title">{{$t('labels.registeredBy')}}</span>
            <span class="field-value">{{research.entryByName}}</span>
            <span class="field-title">{{$t('labels.verifiedBy')}}</span>
            <span class="field-value">{{research.uploadedByName}}</span>
            
            <br><br>
            <h2 style="text-align:left;">{{$t('labels.continents')}}</h2>
            <span>
                <v-chip class="continent" v-if="research.inAfrica">{{$t('labels.africa')}}</v-chip>
                <v-chip class="continent" v-if="research.inAmerica">{{$t('labels.america')}}</v-chip>
                <v-chip class="continent" v-if="research.inAsia">{{$t('labels.asia')}}</v-chip>
                <v-chip class="continent" v-if="research.inAustralia">{{$t('labels.oceania')}}</v-chip>
                <v-chip class="continent" v-if="research.inEurope">{{$t('labels.europe')}}</v-chip>
            </span><br><br><br>
            <h2 style="text-align:left;">{{$t('labels.anatomicParts')}}</h2>
            <span>
            <v-chip class="anatomic-part" v-if="research.cranium">{{$t('labels.cranium')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.lowerJaw">{{$t('labels.lowerJaw')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.teeth">{{$t('labels.teeth')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.hyoid">{{$t('labels.hyoid')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.vertebrae">{{$t('labels.vertebrae')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.ribs">{{$t('labels.ribs')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.girdles">{{$t('labels.girdles')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.limbs">{{$t('labels.limbs')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.osteoderms">{{$t('labels.osteoderms')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.shell">{{$t('labels.shell')}}</v-chip>
            </span><br><br><br>
            <h2 style="text-align:left;">{{$t('labels.variability')}}</h2>
            <span>
            <v-chip class="variability" v-if="research.intraspecificVariation">{{$t('labels.intraspecificVariation')}}</v-chip>
            <v-chip class="variability" v-if="research.ontogeneticVariation">{{$t('labels.ontogeneticVariation')}}</v-chip>
            <v-chip class="variability" v-if="research.sexDim">{{$t('labels.sexDim')}}</v-chip>
            </span><br><br><br>
            <h2 style="text-align:left;">{{$t('labels.dataType')}}</h2>
            <span>
            <v-chip class="data-type" v-if="research.hasDescription">{{$t('labels.hasDescription')}}</v-chip>
            <v-chip class="data-type" v-if="research.hasFigure">{{$t('labels.hasFigure')}}</v-chip>
            <v-chip class="data-type" v-if="research.hasScoring">{{$t('labels.hasScoring')}}</v-chip>
            <v-chip class="data-type" v-if="research.hasGeometricMorphology">{{$t('labels.hasGeometricMorphology')}}</v-chip>
            <v-chip class="data-type" v-if="research.hasFiniteElementsAnalysis">{{$t('labels.hasFiniteElementsAnalysis')}}</v-chip>
            </span><br><br><br><h2 style="text-align:left;">{{$t('labels.techniques')}}</h2>
            <span>
            <v-chip class="techniques" v-if="research.drySkeleton">{{$t('labels.drySkeleton')}}</v-chip>
            <v-chip class="techniques" v-if="research.clearingAndStaining">{{$t('labels.clearingAndStaining')}}</v-chip>
            <v-chip class="techniques" v-if="research.ctScan">{{$t('labels.ctScan')}}</v-chip>
            <v-chip class="techniques" v-if="research.xRays">{{$t('labels.xRays')}}</v-chip>
            <v-chip class="techniques" v-if="research.histological">{{$t('labels.histological')}}</v-chip>
            </span><br><br><br>
        </v-layout>
        <v-dialog
            v-model="showDeletionDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{$t('labels.confirmDeletion')}}
                </v-card-title>
                <v-card-text>
                    {{$t('labels.reallyDelete')}} {{$t('labels.thisResearch')}}?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="showDeletionDialog = false"
                >
                    No
                </v-btn>
                <v-btn
                    color="red"
                    style="color:white"
                    text
                    @click="deleteResearch();showDeletionDialog = false"
                >
                    {{$t('labels.yesDelete')}}
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="showDeletedToast">
            {{$t('labels.researchDeleted')}}!
        </v-snackbar>
        <div class="bottom-bar-holder">
            <div class="bottom-bar">
                <v-layout
                    justify-center
                    style="padding:0"
                >
                    <!--<v-btn
                        color="white"
                        style="background:#4caf50;font-size:20px;float:right;"
                        flat
                    >
                        <v-icon>delete</v-icon>&nbsp;&nbsp;Elimina
                    </v-btn>-->
                    <v-btn
                        color="white"
                        style="background:rgb(244, 67, 54);font-size:20px;float:right;"
                        flat
                        @click.native="showDeletionDialog=true"
                    >
                        <v-icon>delete</v-icon>&nbsp;&nbsp;{{$t('labels.delete')}}
                    </v-btn>
                </v-layout>
            </div>
        </div>
    </v-container>
    
</template>

<script>
const axios = require('axios').default;
export default {
    name: 'Research',
    data: function(){
        return{
            showDeletionDialog: false,
            showDeletedToast: false,
            searchedText: "",
            research:{}
        };
    },
    mounted: function(){
        let vm = this;
        vm.getResearch();
    },
    methods:{
        getResearch(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "researches/getResource.php?researchId="+vm.$route.params.researchId,
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.research = response.data.resource;
                } 
                else{
                    alert(vm.$t('labels.errorLoading'));
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert(vm.$t('labels.errorLoading'));
                    console.error(error)
                }
            });
        },
        deleteResearch(){
            let vm = this;
            axios({
                method: "DELETE",
                url: vm.$API_BASE_URL + "researches/delete.php",
                data: {
                    "researches":[vm.$route.params.researchId]
                },
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.showDeletedToast = true;
                    vm.$router.push({name: 'researches'});
                } 
                else{
                    alert(vm.$t('labels.errorLoading'));
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert(vm.$t('labels.errorLoading'));
                    console.error(error)
                }
            });
        }
    }
}
</script>
